<template>
    <b-form-group
        :label="inputLabel"
        :label-for="inputId"
        :class="{
            'required-field': required,
        }"
    >
        <b-form-file
            ref="file-input"
            :id="inputId"
            :name="inputName"
            v-bind="$attrs"
            :disabled="loading || disabled"
            @input="fileCompressor"
            :placeholder="placeholder"
        ></b-form-file>
    </b-form-group>
</template>

<script>
import { mapGetters } from 'vuex'
import request from '@/utils/request'
import { compressImageIfNeeded } from '@/utils/cropperHelper'

export default {
    /*
  |--------------------------------------------------------------------------
  | Component > components
  |--------------------------------------------------------------------------
  */
    components: {}, // End of Component > components

    /*
  |--------------------------------------------------------------------------
  | Component > props
  |--------------------------------------------------------------------------
  */
    props: {
        inputId: {
            type: String,
        },
        inputName: {
            type: String,
        },
        inputLabel: {
            type: String,
        },
        fileType: {
            type: String,
        },
        disabled: {
            type: Boolean,
        },
        value: {
            type: String,
        },
        required: {
            type: Boolean,
            default: false,
        },
        field: {
            type: Object,
        },
        customValue: {
            type: Object,
        },
    }, // End of Component > props

    /*
  |--------------------------------------------------------------------------
  | Component > data
  |--------------------------------------------------------------------------
  */
    data() {
        return {}
    }, // End of Component > data

    /*
  |--------------------------------------------------------------------------
  | Component > computed
  |--------------------------------------------------------------------------
  */
    computed: {
        ...mapGetters(['loading','getField','dataSegmentId']),
        placeholder() {
            if(this.customValue && this.customValue.originalFileName)
            {
                return this.customValue.originalFileName
            }
            if(this.field){
                if( this.field.originalFileNameKey && this.getField(this.field.originalFileNameKey))
                {
                    return this.getField(this.field.originalFileNameKey)
                }
                else if(this.field.placeholder){
                    return this.field.placeholder
                }
            }
            return "Select scan copy (JPG, PNG, PDF or JPEG file)"
        },
    }, // End of Component > methods

    /*
  |--------------------------------------------------------------------------
  | Component > mounted
  |--------------------------------------------------------------------------
  */
    mounted() {
        // console.log('this field',this.field ? this.field.originalFileNameKey : '')
        // console.log('another field',this.customValue)
    }, // End of Component > computed

    /*
  |--------------------------------------------------------------------------
  | Component > methods
  |--------------------------------------------------------------------------
  */
    methods: {
        onHidden() {
            if (this.$refs['file-input']) {
                this.$refs['file-input'].reset()
            }
            if (this.field) {
                if (this.field.originalFileNameKey) {
                    this.$store.commit('updateField', {
                        key: this.field.originalFileNameKey,
                        value: null,
                    })
                }
                this.$store.commit('updateField', {
                    key: this.field.key,
                    value: null,
                })
            }
        },
        encrypt(input) {
            // console.log(input)
            var file = input

            if (file) {
                if (
                    file.type === 'image/jpeg' ||
                    file.type === 'image/jpg' ||
                    file.type === 'image/png' ||
                    file.type === 'application/pdf'
                ) {
                    console.log('File type available')
                    var reader = new FileReader()

                    reader.onload = () => {
                        console.log('File reader on Load')

                        // var key = process.env.VUE_APP_CRYPTO_SECERT_KEY
                        var wordArray = this.CryptoJS.lib.WordArray.create(
                            reader.result
                        ) // Convert: ArrayBuffer -> WordArray
                        var encrypted = this.$encrypt(wordArray,false)// Encryption: I: WordArray -> O: -> Base64 encoded string (OpenSSL-format)

                        var fileEnc = new Blob([encrypted]) // Create blob from string
                        var filename = file.name + '.enc'
                        const myFile = new File([fileEnc], filename, {
                            type: fileEnc.type,
                        })

                        this.onFileInput(myFile, file.name)
                    }

                    console.log('File before Buffer', file)

                    reader.readAsArrayBuffer(file)
                } else {
                    console.log('No file Type')
                    this.$store.commit('setError', 'File format not supported')
                    this.onHidden()
                    // this.$refs['file-input'].reset()
                }
            }

            // reader.readAsArrayBuffer(compressFile);
            // console.log(file)
        },

        async fileCompressor(input) {
            var file = input
            if (file) {
                if (
                    file.type === 'image/jpeg' ||
                    file.type === 'image/jpg' ||
                    file.type === 'image/png' 
                ) { console.log(file.type)
                    let fileConverted = null;
                    fileConverted = await compressImageIfNeeded(input, { maxWidth: 600, thresholdBytes: 2097152 });
                    this.encrypt(fileConverted)
                }
                else if(file.type === 'application/pdf'){
                    this.onFileInput(file, file.name)
                } 
                else {
                    console.log(file.type)
                    console.log('No file Type')
                    this.$store.commit('setError', 'File format not supported')
                    this.onHidden()
                    // this.$refs['file-input'].reset()
                }

                // console.log("File reader on Load");
                //
                // var key = process.env.VUE_APP_CRYPTO_SECERT_KEY;
                // var wordArray = this.CryptoJS.lib.WordArray.create(
                //   readerImage.result
                // ); // Convert: ArrayBuffer -> WordArray
                // var encrypted = this.CryptoJS.AES.encrypt(
                //   wordArray,
                //   key
                // ).toString(); // Encryption: I: WordArray -> O: -> Base64 encoded string (OpenSSL-format)
                //
                // var fileEnc = new Blob([encrypted]); // Create blob from string
                // var filename = fileConverted.name + ".enc";
                // const myFile = new File([fileEnc], filename, {
                //   type: fileEnc.type
                // });
                //
                // this.onFileInput(myFile);
            }
         
        },
        /**
         * Handle when the user selects a file
         *
         * @return {void}
         */
        async onFileInput(file, originalFileName) {
        
            if (file) {
                // this.encrypt(file)
                this.$store.commit('setLoading', true)
                try {
                    const formData = new FormData()
                    formData.append('dataSegmentId', this.dataSegmentId)
                    formData.append('type', this.fileType)
                    formData.append('file', file)

                    const headers = {
                        'Content-Type': 'multipart/form-data',
                    }
                    const { data } = await request.post(
                        'files/encrypt',
                        formData,
                        {
                            headers,
                        }
                    )

                    const fileName = (data && data.data && data.data.fileName) || (data && data.fileName)
                    const displayName = originalFileName || (file.name && file.name.endsWith('.enc') ? file.name.replace(/\.enc$/, '') : file.name) || file.name

                    if (fileName) {
                        // For MultiField component only emit @data event
                        if (this.field && this.field.isDynamicInput) {
                            this.$emit('data', {
                                fileName,
                                originalFileName: displayName,
                                uploadedAt: new Date()
                            })
                        } else {
                            if (this.field) {
                                this.$store.commit('updateField', {
                                    key: this.field.key,
                                    value: fileName,
                                })
                                if (this.field.originalFileNameKey) {
                                    this.$store.commit('updateField', {
                                        key: this.field.originalFileNameKey,
                                        value: displayName,
                                    })
                                }
                            }
                            this.$emit('input', fileName)
                            this.$emit('update:originalFileName', displayName)
                            this.$emit('data', {
                                fileName,
                                originalFileName: displayName,
                                uploadedAt: new Date()
                            })
                        }
                    }
                } catch (error) {
                    this.onHidden()
                    console.log(error)
                    if(this.$isLoggedIn()){
                        this.$store.commit('setError', 'please re-login and try again')
                    }
                    else{
                        this.$store.commit('setError', error)
                   }
                }
                this.$store.commit('setLoading', false)
            }
        }, // End of onFileInput() method
    }, // End of Component > mounted
} // End of export default
</script>
